import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form, Field } from 'formik'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { NeoLoader, NeoOTP, NeoSuccess } from '../../../../components/FormComponents'
import InputError from '../../../../components/InputError/InputError'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import LayoutWithOutAccountCard from '../../../../layout/Layout/layout-without-card'
import { accountsSelector, carouselCurrentItemSelector, getFeatureListSelector } from '../../../../selectors'
import RequestService from '../../../../services/requests.service'
import { DebitCardRequestSchema } from '../../../../schemas/requests'
import TermsAndCondition from '../../../../components/TermsAndConditions/TermsAndCondition'
import { MENU_OPTIONS } from '../../../../layout/Layout/menu-options'
import { DEBIT_CARD_KEYS, VALIDATION_MESSAGES } from '../../../../utils/translation-constants'
import validationConfig from 'custom/config/validation.config.json'
const requestCardConfig = validationConfig['debitCard']['requestCard']

//const menuDetails = MENU_OPTIONS.filter((ele) => ele.key === 'OTHER_SERVICES')[0].children
const subMenuDetails = MENU_OPTIONS.filter((ele) => ele.key === 'REQUESTS')[0].children[2].children[0]
import config from "custom/config/environment"

export default function DebitCardRequest() {
  const history = useHistory()
  const { t } = useTranslation()
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [formValues, setFormValues] = useState()
  const [verifyDetails, setVerifyDetails] = useState({})
  const accountList = useSelector(accountsSelector) || []
  const [otp, setOtp] = useState('')
  const [message, setMessage] = useState('')
  const [cardDetails, setCardDetails]=useState([])
  const [branchList, setBranchList]=useState([])
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const featureList = useSelector(getFeatureListSelector)
  const featureDetails = featureList['REQ_CARD']

  useEffect(()=>{
    getCardDeatils()
    getPickUpBranches()
  },[])

  const getCardDeatils = useCallback(
    async () => {
      try {
        setLoading(true)
        const response = await RequestService.getCardDetails({})
        if (response.status === 200) {
          setCardDetails(response.data)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [],
  )


  const getPickUpBranches = useCallback(
    async () => {
      try {
        setLoading(true)
        const response = await RequestService.getPickUpBranches({})
        if (response.status === 200) {
          setBranchList(response.data["brnachList"])
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [],
  )

  const onVerify = useCallback(
    async (values) => {
      try {
        const selectedAccount = accountList.filter((ele) => ele.accountNo === values.accountNo)[0]     
        const seletedCard= cardDetails.filter((e)=>e.cardProductCode===values.cardProducts)
        let selectedBranch=branchList?.filter((ele)=>ele.BRANCH_CODE===values.deliveryBranch)[0]  
        setLoading(true)
        let reqParams={
          srcAccBranch: selectedAccount.brnCode,
          srcAccCcy: selectedAccount.currency,
          srcAccount: values.accountNo,
          deliveryBranch:values.deliveryMode==="BRANCH"?selectedBranch.ADDRESS:"",
          deliveryMode:values.deliveryMode,
          requestType:values.requestType,
          cardProducts:values.cardProducts
        }
        const response = await RequestService.debitCardRequestVerify(reqParams)
        if (response.status === 200) {
          setVerifyDetails(response.data)
          setFormValues({...reqParams, cardProductName:seletedCard[0].cardProductName})
          setLoading(false)
          setStage(2)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [accountList, cardDetails, branchList],
  )

  const onConfirm = useCallback(async () => {
    try {
      const response = await RequestService.debitCardRequestConfirm({
        ...formValues,
        otpNo: otp || '0000',
      })
      if (response.status === 200) {
        setMessage(response.data['message'])
        setStage(4)
      }
    } catch (err) {}
  }, [formValues, verifyDetails, otp])

  const handleBranchName=useCallback((e, setFieldValue, setTouched, touched)=>{
    let selectedbrnCode=accountList.filter((ele) => ele.accountNo === e.target.value)[0].brnCode
    setFieldValue('deliveryBranch',branchList.filter((ele)=>ele.BRANCH_CODE ===selectedbrnCode)[0].BRANCH_CODE)
    setTouched({...touched,deliveryBranch:false})
  },[branchList, accountList])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP onSubmit={() => onConfirm()} otp={otp} setOTP={setOtp} />
      case 4:
        return <NeoSuccess message={message} linkPath='/requests/debitCard' />
      default:
        return renderForm()
    }
  }

  function renderForm() {
    return (
      <>
      <div className='heading-style'>{t(DEBIT_CARD_KEYS.TITLE)}</div>
        <Formik
          enableReinitialize
          initialValues={{
            accountNo: '',
            deliveryMode:'BRANCH',
            deliveryBranch:'',
            requestType:'',
            cardProducts:''
          }}
          validationSchema={DebitCardRequestSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, handleChange, errors, values, touched, setFieldValue , resetForm, setTouched}) => (
            <Form>
              <div className='form-group col-12'>

                <div className='row mb-3 ml-1'>
                  <div className='custom-control custom-radio custom-control-inline'>
                    <Field
                      tabIndex={'1'}
                      as='input'
                      value='BRANCH'
                      type='radio'
                      id='branch'
                      name='deliveryMode'
                      className='custom-control-input'
                      onClick={resetForm}
                      disabled={isSubmitting}
                    />
                    <label className='custom-control-label' htmlFor='branch'>
                      {t(DEBIT_CARD_KEYS.BRANCH)}
                    </label>
                  </div>
                  <div className='custom-control custom-radio custom-control-inline'>
                    <Field
                      tabIndex={'2'}
                      as='input'
                      type='radio'
                      id='address'
                      name='deliveryMode'
                      value='ADDRESS'
                      className='custom-control-input'
                      onClick={resetForm}
                      disabled={isSubmitting}
                    />
                    <label className='custom-control-label' htmlFor='address'>
                      {t(DEBIT_CARD_KEYS.ADDRESS)}
                    </label>
                  </div>
                </div>
              </div>
              <div className='form-group col-12'>
                <NeoInput
                  tabIndex={'3'}
                  showAsterisk={requestCardConfig["isAccountRequired"]}
                  text={t(DEBIT_CARD_KEYS.ACCOUNT_NO)}
                  name='accountNo'
                  mode='select'
                  list={accountList}
                  keyValue='accountNo'
                  value={values.accountNo}
                  onChange={(e)=>{handleChange(e);
                    handleBranchName(e, setFieldValue, setTouched, touched)
                    setFieldValue('accountNo', e.target.value)
                    // let selectedbrnCode=accountList.filter((ele) => ele.accountNo === e.target.value)[0].brnCode

                    // setFieldValue('deliveryBranch',branchList.filter((ele)=>ele.BRANCH_CODE ===selectedbrnCode)[0].BRANCH_CODE)           
                  }}
                />
                <InputError text={errors.accountNo} touched={touched.accountNo} />
              </div>

              <div className='form-group col-12'>
                <label className='control-label'>
                  {t(DEBIT_CARD_KEYS.CARD)}{' '}
                  {requestCardConfig["isCardProductRequired"] ? '*' : ''}
                </label>
                <Field
                  tabIndex={'4'}
                  as='select'
                  name='cardProducts'
                  onChange={handleChange}
                  className='form-control'>
                  <option value='' disabled defaultValue />
                  {cardDetails?.map((opt, i) => (
                    <option value={opt.cardProductCode} key={i}>
                      {opt.cardProductName}
                    </option>
                  ))}
                </Field>
                <InputError text={errors.cardProducts} touched={touched.cardProducts} />
              </div>

              {values.deliveryMode === "BRANCH" &&
                <div className='form-group col-12'>
                  <label className="control-label">{t(DEBIT_CARD_KEYS.BRANCH_NAME)}{requestCardConfig["isBranchRequired"] ? '*' : ''}</label>
                <Field tabIndex={'5'} as="select" className="form-control" name="deliveryBranch"
                >
                  <option value="" />
                  {branchList.map((ele, i) => (<option key={i} value={ele.BRANCH_CODE}>{ele.ADDRESS}</option>))}
                </Field>
                <InputError text={errors.deliveryBranch} touched={touched.deliveryBranch} />
                </div>
              }
              <div className='form-group col-12'>
                <NeoInput
                  tabIndex={'6'}
                  showAsterisk={requestCardConfig['isRequestTypeRequired'] ? '*' : ''}
                  text={t(DEBIT_CARD_KEYS.REQUEST_TYPE)}
                  name='requestType'
                  mode='select'
                  list={config.CARD_REQUEST_TYPES}
                  keyValue={null}
                  onChange={handleChange}
                  value={values.requestType}
                />
                <InputError text={errors.requestType} touched={touched.requestType} />
              </div>

              <div className='form-group col-12' style={{ marginTop: 30 }}>
                {loading ? (
                  <NeoLoader />
                ) : (
                  <NeoButton
                    tabIndex={'7'}
                    mode={'newDesign'}
                    type='submit'
                    disabled={isSubmitting}
                    text={t(DEBIT_CARD_KEYS.SUBBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
              <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' tabIndex={'8'} onClick={() => history.goBack()}>
                {' '}
                {t(DEBIT_CARD_KEYS.BACK)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(DEBIT_CARD_KEYS.SUBTITLE)}</h3>
        <div>
          <h6 className='label'>{t(DEBIT_CARD_KEYS.ACCOUNT_NO)}</h6>
          <h6 className='value'>{formValues?.srcAccount || "-"}</h6>
        </div>
        <div>
          <h6 className='label'>{t(DEBIT_CARD_KEYS.CARD)}</h6>
          <h6 className='value'>
            {formValues?.cardProductName || "-"}
          </h6>
        </div>
        <div>
          <h6 className='label'>{t(DEBIT_CARD_KEYS.DELIVERY_MODE)}</h6>
          <h6 className='value'>
            {formValues?.deliveryMode || "-"}
          </h6>
        </div>
        {formValues.deliveryMode === "BRANCH" &&
        <div>
          <h6 className='label'>{t(DEBIT_CARD_KEYS.BRANCH_NAME)}</h6>
          <h6 className='value'>
            {formValues?.deliveryBranch || "-"}
          </h6>
        </div>
        }

        <div>
          <h6 className='label'>{t(DEBIT_CARD_KEYS.REQUEST_TYPE)}</h6>
          <h6 className='value'>
            {formValues?.requestType || "-"}
          </h6>
        </div>

        <div className='form-group col-12'>
          <TermsAndCondition module='DEBITCARD' />
        </div>
        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              type='button'
              text={t(DEBIT_CARD_KEYS.CONFIRM)}
              mode={'newDesign'}
              onClick={() => (verifyDetails['otpEnable'] ? setStage(3) : onConfirm())}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
        {t(DEBIT_CARD_KEYS.BACK)}
        </div>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='DEBIT_CARD_REQUEST'
      showEmptySpace={true}
      keyPath={'DEBIT_CARD_REQUEST'}>
      {featureDetails[currentAccountDetail['accountType']] !== 'N' && (
        <div className='new-design-form-style'>{renderSwitch()}</div>
      )}

      {featureDetails[currentAccountDetail['accountType']] === 'N' && (
        <div className='no-data-found'>{t(VALIDATION_MESSAGES.NO_ACCESS)}</div>
      )}
    </LayoutWithOutAccountCard>
  )
}
